export default ({ Vue }) => {
  // eslint-disable-next-line no-extend-native
  Number.prototype.toFixedDown = function (digits) {
    const re = new RegExp('(\\d+\\.\\d{' + digits + '})(\\d)'),
      m = this.toString().match(re)
    return m ? parseFloat(m[1]) : this.valueOf()
  }

  // eslint-disable-next-line no-extend-native
  Number.prototype.roundToX = function (decimal) {
    const x = Math.pow(10, decimal)
    return Math.round(this * x) / x
  }

  // eslint-disable-next-line no-extend-native
  Number.prototype.fixZero = function () {
    const value = Math.abs(this)
    return value < 0.00001 ? 0 : value
  }

  // eslint-disable-next-line no-extend-native
  String.prototype.commaSeparate = function (a) {
    return this.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  // eslint-disable-next-line no-extend-native
  String.prototype.purify = function () {
    return this.replace(/-|\s/g, '')
  }
}
